import React from 'react';
import { useSelector } from 'react-redux';

import FaqDrawer from 'dpl/common/components/FaqDrawer';

import { NAV_SECTION_IDS } from '../utils/constants';

export default function FaqsSection() {
  const { overviewPageData } = useSelector(({ server }) => server);

  return (
    <div
      className="FaqsSection row ph5 pt10 pt0-lg ph20-md"
      id={NAV_SECTION_IDS.FAQS}
    >
      <div className="col-12">
        <h2 className="mb12-md f6 f8-md lh-title">FAQs</h2>
        <FaqDrawer
          faqs={overviewPageData.faqs}
          drawerItemClassName="bb b--black"
          iconCloseName="plus"
          iconOpenName="minus"
        />
      </div>
    </div>
  );
}
